<template>
  <div class="field-set__fields">
    <div
      v-for="(item, index) in fieldArray"
      v-bind:key="`field-${item.name}-${index}`"
      v-bind:class="[
        'field__' + type,
        inline ? 'field__' + type + '--inline': '',
        errors.has(item.name) ? 'is-invalid' : '',
        classname
      ]"
    >
      <input
        v-if="item.label.store"
        v-bind:id="`${getFieldId(item.name)}-${index}`"
        v-bind:type="type"
        v-bind:name="item.name"
        v-bind:value="item.value"
        v-model="answer"
        v-on:change="updateStoreValue(item.label.store.name)"
        v-validate="validate"
      />
      <input
        v-else
        v-bind:id="`${getFieldId(item.name)}-${index}`"
        v-bind:type="type"
        v-bind:name="item.name"
        v-bind:value="item.value"
        v-model="answer"
        v-on:change="updateValue"
        v-validate="validate"
      />
      <label
        v-if="item.label"
        class="label label--inline"
        v-bind:for="`${getFieldId(item.name)}-${index}`"
      >
        <Checkbox
          v-if="type === 'checkbox'"
          class="icon-checkbox"
        />
        <CheckboxChecked
          v-if="type === 'checkbox'"
          class="icon-checkbox--checked"
        />
        <span
          v-if="item.label.text"
          v-html="item.label.text"
        ></span>
        <StoreItem
          v-if="item.label.store"
          v-bind:store="item.label.store"
        />
        <slot name="label-content"></slot>
        <strong
          v-if="item.mandatory"
          class="field--required"
        >*</strong>
      </label>
    </div>
    <div class="is-danger" v-show="errors.has(this.groupFieldName)">
      {{ getErrorMsg(this.groupFieldName) }}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// Icons
import Checkbox from '@/assets/icons/checkbox.svg';
import CheckboxChecked from '@/assets/icons/checkbox-checked.svg';

// Components
import StoreItem from '@/components/stores/StoreItem.vue';

// Mixin
import field from '@/components/mixin/field';

export default {
  name: 'RadioCheckboxGroup',
  mixins: [field],
  props: [
    'fieldArray',
    'type',
    'inline',
    'validate',
    'errorMsg',
    'initial',
    'initialStoreName',
    'classname',
  ],
  components: {
    Checkbox,
    CheckboxChecked,
    StoreItem,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$field-label-dark: $charcoal-dark;

$field-gap: $spacing;

$field-font-size-small: $body-font-size-small;

// Custom styles

.field-set__fields {
  display: flex;
  flex-wrap: wrap;

  .is-danger {
    padding-top: 0;
    margin-top: -7px;
  }
}

.field__radio,
.field__checkbox {
  width: 100%;
}

.field__radio {
  .label {
    font-size: $field-font-size-small;
  }
}

.field__checkbox {
  .label {
    font-weight: 400;
    color: $field-label-dark;
  }
}

.field__radio--inline {
  width: auto;
  margin-right: $field-gap;

  &:last-of-type {
    margin-right: 0;
  }
}

.field__checkbox--inline {
  width: 100%;

  @include small-up {
    width: 50%;
  }
}
</style>
